// src/pages/VerifyGuest.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { updateGuestProfile } from "../services/reservationService";
import { storeGuestData, findMatchingGuest } from "../utils/storage"; // Assuming you have a utility function to handle localStorage

const GuestVerification = () => {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState(localStorage.getItem("guest-firstname") || "");
  const [lastName, setLastName] = useState(localStorage.getItem("guest-lastname") || "");
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const [phone, setPhone] = useState(localStorage.getItem("telephone") || "");
  const [showOnlyPhoneForm, setShowOnlyPhoneForm] = useState(false);
  const [reservationCode] = useState(localStorage.getItem("reservation-code") || "");
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    if (!firstName || !lastName) {
      setShowForm(true);
      return;
    }

    if (firstName && lastName && email && !phone) {
      setShowOnlyPhoneForm(true);
    }

    const { guest, room } = findMatchingGuest({ firstName, lastName });

    if (guest) {
      storeGuestData(guest, room, null, email, phone);
      navigate("/home");
    } else {
      setShowForm(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!firstName || !lastName) return;

    const { guest, room } = findMatchingGuest({ firstName, lastName });
    console.log("Guest found:", guest, "Room:", room);
    if (guest) {
      await updateGuestProfile(reservationCode, {
        email,
        first_name: firstName,
        last_name: lastName,
        room_number: room?.name || "",
        phone,
      }).then((e) => {
        console.log("Guest profile updated successfully:", e.data);
        storeGuestData(guest, room, e.data.guest, email, phone);
        console.log("Guest found, redirecting to home page");
        navigate("/home")
      }).catch((error) => {
        console.error("Error updating guest profile:", error);
        alert(error.response?.data?.error || "An error occurred while updating your profile.");
      })


    } else {
      console.log("Guest not found, redirecting to goodbye page");
      alert("Guest not found. Please check your details.");
      // navigate("/goodbye");
    }
  };

  return (
    <div className="verify-guest">
      {showForm ? (
        <form onSubmit={handleSubmit} className="guest-form">
          <h2>Please confirm your identity</h2>
          <input
            type="text"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="tel"
            placeholder="Phone Number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <button type="submit">Continue</button>
        </form>
      ) : (
        <>
          {showOnlyPhoneForm ? (
            <form onSubmit={handleSubmit} className="guest-form">
              <h2>Please confirm your phone number</h2>
              <input
                type="tel"
                placeholder="Phone Number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
              <button type="submit">Continue</button>
            </form>
          ) : <div className="loading">Verifying guest info...</div>
          }
        </>
      )}
    </div>
  );
};

export default GuestVerification;
